import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SidebarMenuItemComponent } from './sidebar-menu-item/sidebar-menu-item.component';
import { SidebarMenuComponent } from './sidebar-menu.component';


@NgModule({
  declarations: [
    SidebarMenuComponent,
    SidebarMenuItemComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    SidebarMenuComponent,
  ],
})
export class SidebarMenuModule { }
